module.exports = __webpack_public_path__ + "img/crazy_stairs.10e53cf1.jpg";